import * as React from 'react';
import {useParams} from 'src/rerouter/index';
import {useApi} from 'src/hooks/useApi';
import {Loading} from 'src/components/lib/loading/index';
import {Header} from 'src/designSystem2021Components/text-v2';

import css from './mark-task-completion.css';
import maincss from 'src/components/agency-onboard/agency-onboard.css';


export const MarkTaskCompletion = (): React.ReactElement<
  React.ComponentProps<'div'>
> => {
  const {taskId, token} = useParams();

  const apiRequest = useApi(`onboard/task/${taskId}/approve`, {
    method: 'POST',
    data: {
      approval_token: token,
    },
  });

  if (apiRequest.isLoading) {
    return (
      <div className={css.mainContainer}>
        <div className={css.container}>
          <Header className={css.approvingText}>Approving Task</Header>
          <div className={maincss.loaderDiv}>
            <Loading />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={css.mainContainer}>
      <div className={css.container}>
        {apiRequest.error && (
          <div>
            <Header>
              Error Approving Task, Please try after sometime
              <br />
              If Issue persists, connect with the support team.
            </Header>
          </div>
        )}

        {!!apiRequest.result && (
          <div>
            <Header>
              {/* @ts-expect-error - TS2339 - Property 'task_name' does not exist on type '{}'. | TS2339 - Property 'status' does not exist on type '{}'. */}
              {apiRequest.result.task_name} task is {apiRequest.result.status}
            </Header>
          </div>
        )}
      </div>
    </div>
  );
};
